__turbopack_context__.v({
  "body": "JaJPpW_body",
  "bodyAndLog": "JaJPpW_bodyAndLog",
  "button": "JaJPpW_button",
  "content": "JaJPpW_content",
  "icon": "JaJPpW_icon",
  "iconCopy": "JaJPpW_iconCopy",
  "logButton": "JaJPpW_logButton",
  "logo": "JaJPpW_logo",
  "page": "JaJPpW_page",
});
